import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

/**
 * 'sample': '个人页',
 */
const route: AppRouteModule = {
  path: '/profile',
  name: 'Profile',
  component: LAYOUT,
  redirect: '/profile/center',
  meta: {
    icon: 'ant-design:user-outlined',
    title: t('routes.profile.main'),
    orderNo: 900000,
    roles: [20222191],
  },
  children: [
    /**
     * essence: '个人中心',
     */
    {
      path: 'center',
      name: 'ProfileCenter',
      component: () => import('/@/views/profile/center/index.vue'),
      meta: {
        title: t('routes.profile.center'),
        roles: [20222192],
      },
    },
  ],
};

export default route;
